var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_2949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1504 5.11117H10.2032L10.1696 5.0824L12.0875 3.16451V3.12615C11.2927 2.41801 10.3298 1.92522 9.29056 1.69474C8.2513 1.46426 7.17034 1.50378 6.1507 1.80953C5.13105 2.11528 4.2067 2.67707 3.46574 3.44136C2.72478 4.20565 2.1919 5.14697 1.91789 6.1756L2.01858 6.14204C2.75321 5.65847 3.61316 5.40015 4.49266 5.39885C4.7888 5.39459 5.08455 5.42192 5.37489 5.48036C5.38085 5.47741 5.38741 5.47587 5.39407 5.47587C5.40072 5.47587 5.40729 5.47741 5.41325 5.48036C6.00837 4.82473 6.8321 4.42207 7.71502 4.35518C8.59794 4.28829 9.47292 4.56227 10.16 5.12076L10.1504 5.11117Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0102 6.1756C13.6921 4.9977 13.0352 3.93907 12.1211 3.13095L10.1696 5.0824C10.5764 5.41494 10.9024 5.83536 11.1234 6.31204C11.3443 6.78872 11.4542 7.30928 11.445 7.83458V8.1798C13.7609 8.1798 13.7609 11.656 11.445 11.656H7.96405V14.4129H11.4402C12.4047 14.415 13.3445 14.1082 14.1221 13.5375C14.8996 12.9668 15.4741 12.1622 15.7613 11.2415C16.0486 10.3208 16.0336 9.33229 15.7185 8.42072C15.4034 7.50915 14.8047 6.72238 14.0102 6.1756Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49266 14.4177H7.96404V11.632H4.49266C4.24639 11.6315 4.00298 11.5793 3.77825 11.4786L1.76926 13.4923C2.55569 14.0835 3.51363 14.4017 4.49746 14.3985L4.49266 14.4177Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49266 5.39886C3.55117 5.40374 2.63474 5.70271 1.8715 6.25397C1.10825 6.80524 0.536363 7.58124 0.235782 8.47347C-0.0647986 9.3657 -0.0790416 10.3296 0.195045 11.2303C0.469131 12.131 1.01784 12.9236 1.76446 13.4972L3.77825 11.4786C3.52326 11.3621 3.30028 11.1856 3.12839 10.9641C2.95649 10.7427 2.84078 10.4829 2.79117 10.207C2.74155 9.9311 2.7595 9.64728 2.84349 9.37982C2.92747 9.11237 3.07499 8.86923 3.27342 8.67122C3.47185 8.4732 3.71529 8.32619 3.98292 8.24276C4.25055 8.15934 4.53441 8.14198 4.81021 8.19217C5.08601 8.24236 5.34555 8.3586 5.56664 8.53096C5.78772 8.70332 5.96377 8.92667 6.07972 9.1819L8.0935 7.16811C7.67119 6.61462 7.12615 6.16674 6.5013 5.85972C5.87645 5.5527 5.18885 5.39494 4.49266 5.39886Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_2949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGcp);
export default __webpack_public_path__ + "static/media/Logo_gcp.eb68682a24e00a990e46a5a50a96f627.svg";
export { ForwardRef as ReactComponent };